"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textOnlyHasEmojis = void 0;
var emoji_regex_1 = __importDefault(require("emoji-regex"));
var originalEmojiRegex = (0, emoji_regex_1.default)();
function textOnlyHasEmojis(text) {
    // Make sure we match strings that _only_ contain emojis (and whitespace)
    var regex = new RegExp('^(' + originalEmojiRegex.toString().replace(/\/g$/, '') + '|\\s)+$');
    return regex.test(text);
}
exports.textOnlyHasEmojis = textOnlyHasEmojis;
